import React, { useState } from 'react'
import { Button, Card, DatePicker, Drawer, Form, Radio, Select, Input, notification } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'
import { CyprusVisaInOutStatus } from '../actions/chooseStudent'
import { useDispatch } from 'react-redux'
import moment from 'moment'

const ChangeStatusDrawer = (props) => {
  let { visible, onClose, record, onSubmit } = props
  let [status, setStatus] = useState(
    record &&
    record.applications &&
    record.applications.fileReceivedStatus ? 'File Submitted' : 'File Received')
  let [date, setDate] = useState(moment())
  let [processingReady, setProcessingReady] = useState('')
  let [note, setNote] = useState('')

  let dispatch = useDispatch()
  const events = {
    changeStatus: async (record) => {
      let { _id: studentId, applications } = record
      if (status == 'File Received' && !processingReady) {
        return notification.warning({ message: 'Please Select Yes/No' })
      }
      if (!date) {
        return notification.warning({ message: 'Please Choose Date' })
      }
      if (processingReady == 'no' && !note) {
        return notification.warning({ message: 'Please Enter Pendency' })
      }
      let obj = {
        studentId,
        applicationId: applications._id,
        status: status,
        date: date,
        note: note
      }

      let resp = await dispatch(CyprusVisaInOutStatus(obj))
      if (resp && resp.success) {
        setDate('')
        setStatus('')
        onSubmit()
      }
    }
  }

  return (
    <Drawer
      visible={visible}
      title={`Update Status to ${status}`}
      width={'35%'}
      closable={true}
      maskClosable={true}
      onClose={onClose}>
      <Card>
        <Form className={'vertical-form'} autoComplete='off'>
          <Form.Item>
            {status == 'File Received' &&
            <>
              <div className='visa-warning-text mb20'>
                ⚠️ Complete Visa File has been received at Unizportal. Is it ready for processing?
              </div>
              <Radio.Group
                className={'form-control mt10'}
                onChange={(e) => {
                  setProcessingReady(e.target.value)
                  setNote('')
                }}
                value={processingReady}>
                <Radio value={'yes'}>Yes</Radio>
                <Radio value={'no'}>No</Radio>
              </Radio.Group>
            </>
            }

            <InputBox title={'Choose Date'}>
              <DatePicker
                type='date'
                className='form-control'
                value={date}
                onChange={(e) =>
                  setDate(e)
                }
              />
            </InputBox>


            {processingReady == 'no' && (
              <InputBox title='Enter Pendency'>
                <Input.TextArea
                  rows={3}
                  placeholder='Enter Pendency'
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </InputBox>
            )}
          </Form.Item>

          <Form.Item style={{ marginTop: 25 }}>
            <Button type='primary' onClick={() => {
              events.changeStatus(record)
            }}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Drawer>
  )
}

export default ChangeStatusDrawer
